import { render } from "./LoaderWrap.vue?vue&type=template&id=f3ed2432&scoped=true&lang=pug"
import script from "./LoaderWrap.vue?vue&type=script&lang=js"
export * from "./LoaderWrap.vue?vue&type=script&lang=js"

import "./LoaderWrap.vue?vue&type=style&index=0&id=f3ed2432&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3ed2432"]])

export default __exports__